module.exports = __webpack_public_path__ + "static/media/cold.d1330aab.mp3";